import Container from "@components/Atomic/Container/Container";
import { StyledContainer } from "@components/Styled/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import { withSizeGuide } from "./withSizeGuide";

const Wrapper = tw(StyledContainer)`
  flex flex-col items-start justify-between md:flex-row
`;

const Content = tw.div`
  flex flex-col items-center justify-center pt-4 pb-giga w-full
`;

const Title = tw.h3`
  text-h2 leading-h3 mb-4 font-display text-center md:text-[44px]
`;

const Row = styledWithInvalidProps("div")(({ title }: { title: string }) => [
  tw`w-[272px] min-h-mega flex flex-row justify-between items-center border-b tracking-heading`,
  title
    ? tw`font-medium uppercase text-hint`
    : tw`border-tertiary hover:bg-neutral transition-bg`,
]);

const Column = tw.span`
  w-1/3 text-center
`;

export const SizeGuide = withSizeGuide(
  ({ men, menTitle, sizeTitles, styles, women, womenTitle }) => {
    return (
      <Container styles={styles} data-component-type="section-size-guide">
        <Wrapper width="md">
          <Content>
            <Title>{womenTitle}</Title>
            <Row title={true}>
              <Column>US</Column>
              <Column>BARED/EU</Column>
              <Column>CM</Column>
              <Column>IN</Column>
            </Row>
            {women?.map((size) => (
              <Row key={size._key}>
                {sizeTitles?.map((sizeTitle) => (
                  <Column key={sizeTitle}>{size[sizeTitle]}</Column>
                ))}
              </Row>
            ))}
          </Content>
          <Content>
            <Title>{menTitle}</Title>
            <Row title={true}>
              <Column>US</Column>
              <Column>BARED/EU</Column>
              <Column>CM</Column>
              <Column>IN</Column>
            </Row>
            {men?.map((size) => (
              <Row key={size._key}>
                {sizeTitles?.map((sizeTitle) => (
                  <Column key={sizeTitle}>{size[sizeTitle]}</Column>
                ))}
              </Row>
            ))}
          </Content>
        </Wrapper>
      </Container>
    );
  },
);

export default SizeGuide;
